import axios from 'axios'
import tokenService from './token'
import { createApiUrl } from '../config/api'

// Map tag types to their API endpoints
const tagEndpoints = {
  default: '/api/tags/',
  adminCategory: '/api/tags/admin-category-tags/',
  contentCategory: '/api/tags/content-tag-categories/',
  content: '/api/tags/content-tags/',
  medicalSpecialty: '/api/tags/medical-specialty-tags/',
  experience: '/api/tags/experience-tags/',
  demographic: '/api/tags/demographic-tags/',
  tcairem: '/api/tags/tcairem-type-tags/',
  tcairemPersona: '/api/tags/tcairem-persona-tags/',
}


const getBaseUrl = (type = 'default') => createApiUrl(tagEndpoints[type] || tagEndpoints.default)

const retrieve = async (type = 'default', query = '') => {
  const baseUrl = getBaseUrl(type)
  const res = await axios.get(`${baseUrl}?${query}`, tokenService.getAuthHeader())
  return res.data
}

const create = async (type = 'default', obj) => {
  const baseUrl = getBaseUrl(type)
  const res = await axios.post(baseUrl, obj, tokenService.getAuthHeader())
  return res.data
}

const update = async (type = 'default', id, obj) => {
  const baseUrl = getBaseUrl(type)
  const res = await axios.put(`${baseUrl}${id}/`, obj, tokenService.getAuthHeader())
  return res.data
}

const destroy = async (type = 'default', id) => {
  const baseUrl = getBaseUrl(type)
  const res = await axios.delete(`${baseUrl}${id}/`, tokenService.getAuthHeader())
  return res
}

const tagsService = { retrieve, create, update, destroy }

export default tagsService
